var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _rect28, _path5, _rect29, _path6, _path7, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitOfMeasure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 72,
    viewBox: "0 0 70 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    width: 15.9843,
    height: 71.13,
    rx: 1,
    fill: "#CCE5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 2.39767,
    width: 7.99213,
    height: 0.799213,
    fill: "#28345A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 4.79529,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 7.19293,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 9.59058,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 11.9882,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 14.3858,
    width: 7.99213,
    height: 0.799213,
    fill: "#28345A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 16.7835,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 19.1811,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 21.5788,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 23.9764,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 26.3741,
    width: 7.99213,
    height: 0.799213,
    fill: "#28345A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 28.7717,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 31.1693,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 33.567,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 35.9646,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 38.3622,
    width: 7.99213,
    height: 0.799213,
    fill: "#28345A"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 40.7599,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 43.1575,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 45.5552,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 47.9528,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 50.3504,
    width: 7.99213,
    height: 0.799213,
    fill: "#28345A"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 52.7481,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 55.1457,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 57.5433,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 59.941,
    width: 3.99607,
    height: 0.799213,
    fill: "#28345A"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0156,
    y: 62.3387,
    width: 7.99213,
    height: 0.799213,
    fill: "#28345A"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 0.974609,
    y: 63.7526,
    width: 55.9449,
    height: 7.37735,
    rx: 2,
    fill: "#28345A"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4766,
    y: 61.2935,
    width: 12.2956,
    height: 3.0739,
    rx: 1,
    fill: "#28345A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50781 61.1152C6.50781 60.5433 6.98657 60.0879 7.55775 60.1165L12.6556 60.3714L17.7535 60.1165C18.3246 60.0879 18.8034 60.5433 18.8034 61.1152V63.3674C18.8034 63.9197 18.3557 64.3674 17.8034 64.3674H7.50781C6.95553 64.3674 6.50781 63.9197 6.50781 63.3674V61.1152Z",
    fill: "#28345A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3939 25.6363H46.1604L48.6195 61.9083H41.2422L43.3939 25.6363Z",
    fill: "#28345A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6553 20.5131V18.6688L47.0829 17.0294V21.9476L12.6553 20.5131Z",
    fill: "#28345A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1615 28.7102H43.395L42.4728 22.8698L41.5507 17.0294H48.0059L47.0837 22.8698L46.1615 28.7102Z",
    fill: "#28345A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.6247,
    cy: 19.4885,
    r: 4.30345,
    fill: "#28345A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.84434,
    cy: 1.84434,
    r: 1.84434,
    transform: "matrix(-1 0 0 1 46.4688 17.6442)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6559,
    cy: 19.4885,
    r: 3.0739,
    fill: "#28345A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.31738,
    cy: 1.31738,
    r: 1.31738,
    transform: "matrix(-1 0 0 1 13.9736 18.1711)",
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8115,
    y: 59.4492,
    width: 3.68868,
    height: 1.22956,
    rx: 0.5,
    fill: "#28345A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.361328 43.4649H24.9525C24.9525 48.5579 19.4476 52.6866 12.6569 52.6866C5.86625 52.6866 0.361328 48.5579 0.361328 43.4649Z",
    fill: "#28345A"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 12.042,
    y: 48.3831,
    width: 1.22956,
    height: 11.066,
    fill: "#28345A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51195 44.6945L10.5337 21.2015",
    stroke: "#28345A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.575 44.0797L14.5532 20.5868",
    stroke: "#28345A"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 62.0078,
    y: 13.5866,
    width: 0.4,
    height: 2.39764,
    fill: "#28345A"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 62.0078,
    y: 1.59842,
    width: 0.4,
    height: 2.39764,
    fill: "#28345A"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 62.0078,
    y: 25.5748,
    width: 0.4,
    height: 2.39764,
    fill: "#28345A"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 62.0078,
    y: 49.5512,
    width: 0.4,
    height: 2.39764,
    fill: "#28345A"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 62.0078,
    y: 61.5394,
    width: 0.4,
    height: 2.39764,
    fill: "#28345A"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 62.0078,
    y: 37.563,
    width: 0.4,
    height: 2.39764,
    fill: "#28345A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitOfMeasure);
export default __webpack_public_path__ + "static/media/unitOfMeasure.6502b4753c2a4f78fc24a731269c3bc5.svg";
export { ForwardRef as ReactComponent };